// ЗАГОТОВКА офлайн-провайдера (offline-first.md §9).
//
// Сейчас он делает ровно одно: отдаёт вниз по дереву статус сети. Этого достаточно,
// чтобы место для офлайн-слоя существовало с первого дня и его не пришлось потом
// вкручивать в готовое дерево провайдеров.
//
// В T-007 сюда добавляется: старт sync engine (флаш очереди при появлении сети),
// состояние синхронизации в useSyncStore, баннер «нет сети» и индикаторы
// «синхронизируется» / «в очереди» / «ошибка синка». Доменной логики (что именно
// синхронизируется) в провайдере не будет — она живёт в shared/offline и modules/.

import { useMemo } from 'react';
import type { PropsWithChildren, ReactElement } from 'react';

import { useOnlineStatus } from '@/shared/hooks';

import { OfflineContext, type OfflineState } from './offlineContext';

export function OfflineProvider({ children }: PropsWithChildren): ReactElement {
  const isOnline = useOnlineStatus();
  const value = useMemo<OfflineState>(() => ({ isOnline }), [isOnline]);

  return <OfflineContext.Provider value={value}>{children}</OfflineContext.Provider>;
}
